import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
	selector: 'app-read-more',
	templateUrl: './read-more.component.html',
	styleUrls: ['./read-more.component.scss'],
})
export class ReadMoreComponent implements OnInit {
	@ViewChild('textContainer') textContainer: ElementRef;

	@Input() text: string = '';
	@Input() textClass: string;
	@Input() textColor: string = '#000';
	@Input() totalNumberOfLineToDisplay: number;
	currentText: string;
	lineHeight: number = 20;
	isShowReadMoreButton: boolean = false;
	isCollapsed: boolean = false;

	constructor(private elementRef: ElementRef) {}

	ngOnInit() {}

	ngAfterViewInit() {
		let contentHeight = this.textContainer?.nativeElement?.offsetHeight;
		if (contentHeight) {
			if (this.lineHeight * this.totalNumberOfLineToDisplay <= contentHeight) {
				this.isShowReadMoreButton = true;
				this.isCollapsed = true;
			} else {
				this.isCollapsed = false;
			}
		}
	}
}
